import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'luci-switch',
  templateUrl: './luci-switch.component.html',
  styleUrls: ['./luci-switch.component.scss']
})
export class LuciSwitchComponent implements OnInit {

  @Input() onSwitchText: string;
  @Input() offSwitchText: string;
  @Input() isWithoutLabel = false;
  @Input() isLableLeft = false;
  @Input() isSmallButton = false;
  @Input() switchStatus = true;
  @Output() callBackEvent = new EventEmitter();


  constructor() {
  }

  ngOnInit() {
  }

  changeSwitch(status) {
    this.callBackEvent.emit(status);
  }
}
